import { encryptJson } from "../../utils/react-ec-utils";
import {
  CheckInBookingDetails,
  CheckInBookingForm,
  WaitTimeRestaurantDetail,
  CancelCheckInDetails,
  CheckInSuccessResult,
} from "./checkInModels";
import API from "../../Api";
  
// Making Booking
export function makeBooking(CheckInDetails: CheckInBookingDetails) {
  const data = encryptJson(CheckInDetails);

  return API({
    method: "post",
    url: "/api/customers/checkIn/fetch",
    params:{data}
  });
}

// Get WaitTime
export function getWaitTimes(detail: WaitTimeRestaurantDetail) {
  let payload = { "locationId" : detail.locationID};
  const data = encryptJson(payload);
  return API({
    method: "post",
    url:`/merchants/v2/locations/wait-times`,
    data:data
  });
}

// Cancel Booking
export function cancelBooking(CheckInDetails: CancelCheckInDetails) {
  let payload = { "locationId" : CheckInDetails.locationID, "reservationId":CheckInDetails.reservationID, "cancelReason": CheckInDetails?.cancelReason};
  const data = encryptJson(payload);
  return API({
    method: "put",
    url: `/api/customers/reservation/cancel-table?user=customer`,
    data: { "data": data}
  });
}

// Update Booking
export function updateBooking(CheckInDetails: CheckInBookingDetails) {
  return API({
    method: "post",
    url: "/merchants/" + CheckInDetails.locationId + "/reservations",
    data: CheckInDetails,
  });
}

// Get Booking
export function getBooking(reservationID: string) {
  let payload = { "reservationId":reservationID};
  const data = encryptJson(payload);
  return API({
    method: "post",
    url: "/api/customers/checkIn/reservationId",
    data: { "data": data}
  });
}

// export function getSessionApi(locationId:string) {
//   return API({
//     method: "get",
//     url: `/api/customers/reservation/generate-reservation-slot/${locationId}`,
//   });
// }

export function getSessionApi(data:any) {
  return API({
    method: "get",
    url: `/api/customers/reservation/generate-reservation-slot/${data.locationId}?guestCount=${data.GuestSize}&date=${data.Date}`,
  });
}

export function makeReservationApi(ReservationDetails: CheckInBookingDetails) {
  const data = encryptJson(ReservationDetails);

  return API({
    method: "post",
    url: "/api/customers/checkIn/fetch",
    params:{data}
  });
}
